import styled from 'styled-components'

export const Container = styled.div`
    min-height: calc(
            100vh - ${(props) => {return props.theme.headerHeight}}px
                - ${(props) => {return props.theme.footerHeight}}px
        );
    color: ${(props) => {return props.theme.colorPrimary}};
    display: flex;
    flex-direction: column;

    > div {
        display: flex;
        flex-direction: column;
        padding: 30px 10px 0;
        height: 1fr;
        width: 1100px;
        max-width: 100%;
        margin: 0 auto;
    }

    .hidden {
        display: none !important;
    }

    .center {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .content {
        box-shadow: ${(props) => {return props.theme.shadow}};
        border: 1px solid #eee;
        border-radius: 10px;
        padding: 30px 20px;
        display: flex;
        flex-wrap: wrap;

        .avatar {
            width: 30%;
            min-height: 200px;
            border: 1px solid #eee;
            border-radius: 20px;
            color: #ccc;

            @media screen and (max-width: 900px) {
                width: 100%;
            }
        }

        button {
            background-color: #f3f3f3;
            margin: 20px 0 0;
            height: 40px;
            width: 30%;
            border-radius: 6px;
            outline: none;
            border: none;
            cursor: pointer;
            color: #333;

            &:hover {
                background-color: #eee;
            }

            @media screen and (max-width: 900px) {
                width: 100%;
            }
        }

        .info {
            width: 70%;
            padding: 0 30px;
            p {
                margin: 0;
                font-size: 1.3rem;
            }

            label {
                margin: 8px 0 0;
                color: #aaa;
            }
        }

        .form-box {
            width: 70%;
            padding-left: 20px;
            label {
                margin: 8px 0 0;
                color: #333;
            }
            .action-buttons {
                display: flex;
                flex-wrap: wrap;
                align-items: center;

                .save-button {
                    background-color: ${(props) => {
        return props.theme.colorPrimary
    }};
                    color: white;
                    user-select: none;
                }
            }
        }

        @media screen and (max-width: 900px) {
            padding: 20px 10px;
            .info {
                width: 100%;
            }
            .form-box {
                width: 100%;
                padding-left: 0;
            }
        }
    }
`
